export default __webpack_public_path__ + "static/media/tela-bege-azul.3a81e758.png";